import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, Subject } from 'rxjs';
import { retry, catchError, distinctUntilChanged } from 'rxjs/operators';

import { SearchResults, SearchContent, NewsArticles, SCREEN_SIZE } from '../Models/common.model';


@Injectable({
    providedIn: 'root'
})

export class GlobalSearchService {
    private apiURL = window.location.href.split('?')[0];
    private queryParams = (window.location.href.split('?').length > 1) ? window.location.href.split('?')[1] : "";

    get onResize$(): Observable<SCREEN_SIZE> {
        return this.resizeSubject.asObservable().pipe(distinctUntilChanged());
    }

    private resizeSubject: Subject<SCREEN_SIZE>;

    onResize(size: SCREEN_SIZE) {
        this.resizeSubject.next(size);
    }

    constructor(private http: HttpClient) {
        this.resizeSubject = new Subject();
    }
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }

    getStaticData(): Observable<string> {
        return this.http.get<string>(this.apiURL + '/GetStaticDataJson/')
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getSearchResults(p, sortOrder): Observable<SearchResults<SearchContent>> {
        var backToTopstring = this.queryParams.indexOf('#');
        if (backToTopstring != -1) {
            this.queryParams = this.queryParams.substring(0, backToTopstring);
        }
        return this.http.get<SearchResults<SearchContent>>(this.apiURL + '/GetSearchResults/?p=' + p + "&" + this.queryParams + "&sortorder=" + sortOrder)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getSearchResultFacet(p, filters, sortOrder): Observable<SearchResults<SearchContent>> {
        var backToTopstring = this.queryParams.indexOf('#');
        if (backToTopstring != -1) {
            this.queryParams = this.queryParams.substring(0, backToTopstring);
        }
        var url = this.apiURL + '/GetSearchResults/?p=' + p + "&" + this.queryParams + "&filters=" + JSON.stringify(filters) + "&sortorder=" + sortOrder;
        
        return this.http.get<SearchResults<SearchContent>>(url)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getVideoSearchResults(p): Observable<SearchResults<NewsArticles>> {
        return this.http.get<SearchResults<NewsArticles>>(this.apiURL + '/GetSearchResults/?p=' + p + "&" + this.queryParams)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getVideoSearchKeywordResults(p, searchKeyword): Observable<SearchResults<NewsArticles>> {
        return this.http.get<SearchResults<NewsArticles>>(this.apiURL + '/GetSearchResults/?p=' + p + "&" + "q=" + searchKeyword)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }
}
